module.exports = __webpack_public_path__ + "static/tusas-logo-yeni-d7420b3bb71bfb65b555484f993c9e9e.png";